<template>
  <aside id="left-panel" class="left-panel">
    <nav class="navbar navbar-expand-sm navbar-default fix-side side-scroll">
      <SidebarHeader />
      <div id="main-menu" class="main-menu collapse navbar-collapse">
        <ul class="nav navbar-nav">
          <template v-for="(item, index) in permittedNavItems">
            <template v-if="item.title">
              <SidebarNavTitle
                v-bind:key="index+'navtitle'"
                :name="item.name"
                :classes="item.class"
                :wrapper="item.wrapper"
              />
            </template>
            <template v-else-if="item.divider">
              <li v-bind:key="index+'divider'" class="divider"></li>
            </template>
            <template v-else>
              <template v-if="item.children">
                <!-- First Level Dropdown -->
                <SidebarNavDropdown
                  v-bind:key="index+'dropdown'"
                  :name="item.name"
                  :url="item.url"
                  :icon="item.icon"
                >
                  <template v-for="( childL1, index ) in item.children">
                    <template v-if="childL1.children">
                      <!-- Second Level Dropdown menu -->
                      <SidebarNavDropdown
                        v-bind:key="index+'sidedropdown'"
                        :name="childL1.name"
                        :url="childL1.url"
                        :icon="childL1.icon"
                      >
                        <li
                          class="nav-item"
                          v-for="(childL2, index) in childL1.children"
                          v-bind:key="index+'dropdownli'"
                        >
                          <SidebarNavLink
                            :name="childL2.name"
                            :url="childL2.url"
                            :icon="childL2.icon"
                            :badge="childL2.badge"
                            :variant="item.variant"
                          />
                        </li>
                      </SidebarNavDropdown>
                    </template>
                    <template v-else>
                      <SidebarNavItem v-bind:key="index+'navitem'" :classes="item.class">
                        <SidebarNavLink
                          :name="childL1.name"
                          :url="childL1.url"
                          :icon="childL1.icon"
                          :badge="childL1.badge"
                          :variant="item.variant"
                        />
                      </SidebarNavItem>
                    </template>
                  </template>
                </SidebarNavDropdown>
              </template>
              <template v-else>
                <SidebarNavItem v-bind:key="index+'dropdownitem'" :classes="item.class">
                  <SidebarNavLink
                    :name="item.name"
                    :url="item.url"
                    :icon="item.icon"
                    :badge="item.badge"
                    :variant="item.variant"
                  />
                </SidebarNavItem>
              </template>
            </template>
          </template>
        </ul>
      </div>
      <!-- /.navbar-collapse -->
    </nav>
  </aside>
  <!-- /#left-panel -->
</template>
<script>
import SidebarHeader from "./sidebar/SidebarHeader.vue";
import SidebarNavDropdown from "./sidebar/SidebarNavDropdown.vue";
import SidebarNavTitle from "./sidebar/SidebarNavTitle.vue";
import SidebarNavLink from "./sidebar/SidebarNavLink.vue";
import SidebarNavItem from "./sidebar/SidebarNavItem.vue";
import SidebarFooter from "./sidebar/SidebarFooter.vue";
import auth from "./../lib/auth";

export default {
  name: "sidebar",
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {
    SidebarHeader,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarFooter
  },
  data() {
    return {
      sections: [],
      permittedNavItems: []
    };
  },
  created() {
    this.sections = auth.user.sections || [];
    console.log(this.sections, this.navItems, this.permittedNavItems);
    this.getNavItems();
  },
  methods: {
    handleClick(e) {
      e.preventDefault();
      console.log("handle", e);
      e.target.parentElement.classList.toggle("show");
    },
    getNavItems() {
      let sections = this.sections;
      this.permittedNavItems = this.navItems.filter(function(nav, index) {
        console.log(sections.indexOf(nav.name), sections.indexOf("Activity") === -1);
        return sections.indexOf(nav.name) > -1 &&
          sections.indexOf("Activity") === -1
          ? true
          : false;
      });
      // this.permittedNavItems = this.navItems;
      console.log("Permitted Nav", this.permittedNavItems);
    }
  },
  watch: {
    navItems: function(value) {
      this.permittedNavItems = this.value.filter(function(nav, index) {
        return this.sections.indexOf(nav.name) > -1 ||
          sections.indexOf("Activity") === -1
          ? true
          : false;
      });
      console.log("Permitted Nav", this.permittedNavItems);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue